import { Component, OnInit, HostListener, ElementRef  } from '@angular/core';
import { NotificationService } from './notification.service'
import "rxjs/add/observable/interval";
import {Observable} from 'rxjs/Observable';
import { GlobalDataService } from '../../services/global-data.service';

@Component({
  selector: 'app-notification',
  providers: [ NotificationService ],
  template: `
            <div class="notification" [ngClass]="{'active' : is_open}" (click)="toggle()">
            <i class="fa fa-bell"></i>
            <span [style.background-color]="unread_count>0 ? 'red' : 'green'" class="notification_count">{{ unread_count }}</span>
            </div>
            <div *ngIf="is_open" class="notification-content">
                    <div class="notification_header" align="center">{{ header_text }}</div>
                      <div class="content_items">
                             <ul class="items">
                                 <li *ngFor="let item of messages;let i = index" [style.background-color]="i%2==0 ? '#edeff1' : 'white'" class="item">
                                    <span class="date">Дата: {{message_type==0 ? item.created_at : item.read_at}}</span>
                                    <button *ngIf="!message_type" class="read_button" (click)="readedMessage(item.id)">Прочитан</button>
                                    <div class="message"> {{ item['data'].message }}</div>
                                 </li>
                            </ul>
                      </div>
                      <div class="notification_footer" (click)="onReadMessage()" align="center">{{ footer_text}}</div>
            </div>
            `,
  styles: [
    `
  .notification{
    padding: 10px 0px 10px 10px;
    margin-top: -8px;
    color:white;
  }
 .active{
    background-color:  rgb(228, 128, 28);
  }
  .notification:hover{
    color: white;
    padding: 10px 0px 10px 10px;
    margin-top: -8px;
    background-color:  rgb(228, 128, 28);
  }
  .notification_count{
    border-radius: 2px;
    color: white;
    padding: 1px 3px;
    font-size: 10px;
    position: relative;
    top: -12px;
    right: 8px;
  }
  .notification-content{
    position: fixed;
    top: 50px;
    margin-left: -215px;
    width: 250px;
    height: 272px;
    background-color: white;
    box-shadow: 3px 3px 10px 0px #000000;
  }
  .content_items{
    overflow-y: auto;
    height: 200px;
    background-color: #f6f9fb;
  }
  .date{
    font-size: 12px;
  }
  .read_button{
    font-size: 11px;
    border: solid 1px #5cb85c;
    padding: 4px 8px 4px 8px;
    margin-left: 6px;
    background-color: #5cb85c;
    color: white;
    border-radius: 3px;
  }
  .message{
    font-size: 14px;
    padding-top: 4px; 
  }
  .read_button:hover{
    font-size: 11px;
    border: solid 1px #4cae4c;
    padding: 4px 8px 4px 8px;
    margin-left: 6px;
    background-color: #4cae4c;
    color: white;
    border-radius: 3px;
  }
  .notification_header{
    padding: 8px;
    border-bottom: solid 1px #a9a6a6;
    background-color: #eef0f2;
    color: #003246;
    font-weight: bold;
  }
  .items{
    list-style-type: none;
    margin-left: -40px;
  }
  .item{
    border-bottom: solid 1px #d4d1d1;
    padding: 8px 6px 6px 10px;
    color: #353535;
    border-radius: 10px;
  }
  .notification_footer{
    padding: 9px;
    border-top: solid 1px #c1c1c1;
    background-color: #f1f2f4;
    color: #003246;
    font-weight: 600;
    border-top-left-radius: 10px;
  }
  .notification_footer:hover{
    padding: 9px;
    border-top: solid 1px grey;
    background-color: #e4801c;
    color: #ffffff;
    font-weight: 600;
  }

  `
]
})
export class NotificationComponent implements OnInit {

  is_open:boolean = false;
  messages: any =[];
  countDiff:number;
  unread_count:number=0;
  header_text:string="";
  footer_text:string = "Посмотреть прочитанных";
  message_type:boolean = false;
  isShowToast: boolean = false;

  @HostListener('document:click', ['$event.target'])
  public onClick(targetElement) {
    const isClickedInside = this._elementRef.nativeElement.contains(targetElement);
    if (!isClickedInside) {
       this.is_open=false;
    }
  }

  constructor(
    private notificationService: NotificationService,
    private global: GlobalDataService,
    private _elementRef : ElementRef) { }

  ngOnInit() {
    this.getUnreadCount();
    this.getUnreadByInterval();
    this.getUnreadMessage();
  }

  getUnreadByInterval(){
    Observable.interval(2*60*1000).subscribe(() => { 
       this.getUnreadCount();
       this.getUnreadMessage();
     });
  }

beep() {
    var snd = new Audio("notification.mp3");  
    snd.play();
  }

  getUnreadCount(){
    this.notificationService.getUnreadCountNotifacation().subscribe(response=>{
      this.unread_count=response['data'].count;
      
      if(this.countDiff!=this.unread_count){
        this.beep();
        if(this.global.isNeedNotificate){
          this.isShowToast = true;
        }
        this.global.isNeedNotificate = true;
      }
      this.countDiff = this.unread_count;
      this.header_text= this.unread_count + " новых уведомлении";});
  }
  getUnreadMessage(){
    this.messages=[];
    this.notificationService.getNotification('unread').subscribe(response=>{
      this.messages=response['data'];

      if(this.isShowToast){
        this.isShowToast = false;
        this.global.sendMessageNotification(this.messages[0]['data']['message']);
      }

    });
  }

  getReadMessage(){
    this.messages=[];
    this.notificationService.getNotification('read').subscribe(response=>{
      this.messages=response['data'];
    });
  }

  onReadMessage(){
    this.message_type = !this.message_type;
    
    if(this.message_type){
      this.getReadMessage();
      this.footer_text="Посмотреть непрочитаных";
      this.header_text= "Прочитанные уведомления";
    }else{
      this.getUnreadMessage();
      this.getUnreadCount();
      this.footer_text="Посмотреть прочитанных";
    }
  }

  
  readedMessage(id:string){
    this.global.isNeedNotificate = false;
      this.notificationService.changeMessageToRead(id).subscribe(response=>{
        this.getUnreadCount();
        this.getUnreadMessage();
      
      })
  }

  toggle(){
      this.is_open=!this.is_open;
  }

}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/utils/notification/notification.component.ts